// Генерируем размеры обуви от 3.5 до 18 с шагом 0.5
export const SHOE_SIZES: string[] = [];

for (let size = 3.5; size <= 18; size += 0.5) {
  SHOE_SIZES.push(size.toString());
}

// Результат: ['3.5', '4', '4.5', '5', '5.5', ..., '17.5', '18']

// Размеры для одежды и аксессуаров
export const CLOTHING_SIZES: string[] = [
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  'XXXL',
  '4XL',
  '5XL'
];

// ONE SIZE для одежды и аксессуаров
export const ONE_SIZE = 'ONE SIZE';

